import React from 'react';
import {Link} from 'react-router'

// Components

import Button from '../components/button.jsx'

export default class home extends React.Component {

    componentDidMount() {
        $("html, body").animate({scrollTop: 0}, 0);

        var controller = new ScrollMagic.Controller({globalSceneOptions: {duration: "70%"}});
        $('.animate').each(function (i, ele) {
            new ScrollMagic.Scene({triggerElement: ele, offset: -200})
            //.addIndicators()
                .setTween($(ele).find('.animate-this'), 1,
                    {
                        x: 0,
                        y: 0,
                        opacity: 1
                    }).addTo(controller);
        })
    }

    render() {
        return <section>
            <a href="#/categories/xbow">
                <div style={{
                    backgroundImage: "url(public/images/xbow.jpg)",
                    backgroundSize: "cover",
                    paddingTop: "20vw",
                    paddingBottom: "20vw",
                    wordBreak: "break-all",
                    color: "white",
                    position: "relative"
                }}>
                    <div className="intro-wrapper">
                        <div className="row">
                            <div className="gr-4 text-right">
                                <h1>XBOW</h1>
                                <Button href="#/categories/xbow" extra="inverted">TAKE A RIDE</Button>
                            </div>
                            <div className="gr-9">&nbsp;</div>
                        </div>
                    </div>
                    <div style={{position: "absolute", bottom: "3vw", left: 0, right: 0, textAlign: "center"}}>
                        <a className="arrow bounce">
                            <svg xmlns="http://www.w3.org/2000/svg" width="96.34" height="57.28"
                                 viewBox="0 0 96.34 57.28" style={{width: "50px", cursor: "pointer", fill: "white"}}>
                                <path className="cls-1"
                                      d="M1708.35,2308.12l-48.08-48.08,9.19-9.19,48.08,48.08Z"
                                      transform="translate(-1660.28 -2250.84)"></path>
                                <path className="cls-1"
                                      d="M1699.36,2298.94l48.09-48.08,9.19,9.19-48.09,48.09Z"
                                      transform="translate(-1660.28 -2250.84)"></path>
                            </svg>
                        </a>
                    </div>
                </div>
            </a>

            <div className="">

                <div className="row row-align-middle">
                    <div className="gr-4 text-right">
                        <div className="padding-right-50">
                            <h1>BOLD<br/>IDEAS</h1>
                            <Button href="#/categories/boldideas">GO INSIDE</Button>
                        </div>
                    </div>
                    <div className="gr-8">
                        <div className="image">
                            <a href="#/categories/boldideas">
                                <img src="public/images/20160723-JK2_2343-Bearbeitet-2.jpg" alt=""
                                     className="image-resp pull-right"/>
                                <div className="clearfix"></div>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row row-align-middle" style={{paddingBottom: "0vw"}}>
                    <div className="gr-8">
                        <div className="image">
                            <a href="#/categories/visualbranding">
                                <img src="public/images/20150206-JMK_8593.jpg" alt="" className="image-resp pull-left"/>
                                <div className="clearfix"></div>
                            </a>
                        </div>
                    </div>
                    <div className="gr-4">
                        <div className="padding-left-50">
                            <h1>VISUAL<br/>BRAND<br/>ING</h1>
                            <Button href="#/categories/visualbranding">CLICK HERE</Button>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                </div>


                <div className="row row-align-middle">
                    <div className="gr-4">
                        <div className="text-right padding-right-50">
                            <h1>STORY<br/>TELLING</h1>
                            <Button href="#/categories/storytelling">BLA BLA</Button>
                        </div>
                    </div>
                    <div className="gr-8">
                        <div className="image">
                            <a href="#/categories/storytelling">
                                <img src="public/images/20160429-JK2_2796-Bearbeitet.jpg" alt=""
                                     className="image-resp pull-right"/>
                                <div className="clearfix"></div>
                            </a>
                        </div>
                    </div>
                </div>

                <div style={{marginTop: "0vw"}}>
                    <a href="#/categories/people">
                        <div style={{
                            backgroundImage: "url(public/images/20170324-JK5_9160.jpg)",
                            backgroundSize: "cover",
                            paddingTop: "20vw",
                            paddingBottom: "20vw",
                            wordBreak: "break-all",
                            color: "white"
                        }}>
                            <div className="intro-wrapper">
                                <div className="row">
                                    <div className="gr-8">&nbsp;</div>
                                    <div className="gr-4 text-left">
                                        <h1>PEOPLE PHOTO<br/>GRAPHY</h1>
                                        <Button href="#/categories/people" extra="inverted">HAVE A LOOK</Button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </a>
                </div>


                <div className="container" style={{paddingTop: "8vw", paddingBottom: "8vw"}}>
                    <div className="row row-align-middle">
                        <div className="gr-4">
                            <div className="margin-right-50 text-right relative">
                                <h1 style={{position: "absolute", right: 0}}>LOOK<br/>BOOK</h1>
                                <h1 style={{color: "white", position: "relative", zIndex: -1, opacity: 0}}>LOOK<br/>BOOK
                                </h1>
                                <Button href="#/categories/lookbook">SOME TEXT HERE</Button>
                            </div>
                        </div>
                        <div className="gr-4">
                            <a href="#/categories/lookbook">
                                <img src="public/images/20150422-JMK_7349.jpg" alt=""
                                     className="image-resp"/>
                            </a>
                        </div>
                        <div className="gr-4">
                            <div>
                                <a href="#/categories/lookbook">
                                    <img src="public/images/20150422-JK4_3634.jpg" alt=""
                                         className="image-resp pull-left" style={{width: "50%"}}/>
                                </a>
                                <div className="clearfix"></div>
                            </div>
                            <div style={{marginTop: "20px"}}>
                                <a href="#/categories/lookbook">
                                    <img src="public/images/20150422-JK4_3589.jpg" alt=""
                                         className="image-resp pull-left"/>
                                </a>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                        <div className="clearfix"></div>
                    </div>
                </div>


            </div>
        </section>
    }
}



// WEBPACK FOOTER //
// ./src/scripts/pages/home.jsx